import React, { useContext } from "react";

import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

//Screens
import Login from "../screens/Auth/SignIn";
import RecoverPassword from "../screens/Auth/RecoverPassword";
import SignUp from "../screens/Auth/SignUp";
import UserInfo from "../screens/Auth/UserInfo";
import Err404 from "../screens/Err404";
import Home from "../screens/Home";
import Dashboard from "../screens/Dashboard";
//--> Dashboard
// import Agency from "../screens/Dashboard/Agency";
import Agents from "../screens/Dashboard/Agents";
import Tasklist from "../screens/Dashboard/Tasklist";
import Feedback from "../screens/Dashboard/Feedback";
//--> Policies
import AppPolicy from "../screens/Policies/AppPolicy";

//Context
import { AuthContext } from "../context/AuthContext";

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <AuthRoute exact path="/" component={Home} />
        <AuthRoute exact path="/SignIn" component={Login} />
        <AuthRoute exact path="/SignUp" component={SignUp} />
        <AuthRoute
          exact
          path="/Password-Recovery"
          component={RecoverPassword}
        />
        <PrivateRoute
          exact
          path="/Agency-detailed-information"
          component={UserInfo}
        />
        <ProtectedRoute exact path="/Dashboard" component={Dashboard} />
        {/* <ProtectedRoute path="/Dashboard/Agency" component={Agency} /> */}
        <ProtectedRoute path="/Dashboard/Agents" component={Agents} />
        <ProtectedRoute path="/Dashboard/Tasklist" component={Tasklist} />
        <ProtectedRoute path="/Dashboard/Feedback" component={Feedback} />
        <Route path="/App-PrivacyPolicy" component={AppPolicy} />
        <Route component={Err404} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isAuth, user } = useContext(AuthContext);

  // console.log("Protected --> ", isAuth);
  // console.log("Protected User --> ", user);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth && user["phoneNumber"] !== "" ? (
          <Component {...props} />
        ) : isAuth && user["phoneNumber"] === "" ? (
          <Redirect
            to={{
              pathname: "/Agency-detailed-information",
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: "/SignIn",
            }}
          />
        )
      }
    />
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuth, user } = useContext(AuthContext);

  // console.log("Private --> ", isAuth);
  // console.log("Private User --> ", user);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth && user["phoneNumber"] === "" ? (
          <Component {...props} />
        ) : isAuth && user["phoneNumber"] !== "" ? (
          <Redirect
            to={{
              pathname: "/Dashboard",
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: "/SignIn",
            }}
          />
        )
      }
    />
  );
};

const AuthRoute = ({ component: Component, ...rest }) => {
  const { isAuth } = useContext(AuthContext);

  // console.log("Auth --> ", isAuth);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuth ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/Dashboard",
            }}
          />
        )
      }
    />
  );
};
